module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/1SNVAlQjryPlxIvhQI9KVz-7e3710d5f4a273a11e78f4e40e538394.jpg";